import axios from 'axios'
import store from '@/store'

const API_BASE_URL = process.env.VUE_APP_API_URL || 'https://clubtest.intrare.app'

export const kidsGolfTournamentAPI = {
  completeRegistration (data) {
    return axios.post(
      `${API_BASE_URL}/temp-tournament-members/complete-registration/`,
      data
    )
  },

  getKidsFamilies (params) {
    return axios.get(
      `${API_BASE_URL}/temp-tournament-members/kids-families/`,
      {
        headers: {
          'Authorization': `Token ${store.getters.getToken}`
        },
        params
      }
    )
  }
}
